import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const CONFIRM_BG = '#1C1C1C';
export const CONFIRM_TITLE = '#FFFFFF';
export const CONFIRM_DESCRIPTION = '#ABABAB';

/**
 * Por encima de cualquier modal de la app (los más altos andan en 2200-2300).
 * La confirmación siempre se pide **desde** otra pantalla: con el z-index por
 * defecto de MUI (1300) queda atrás y el usuario ve la app bloqueada sin saber
 * por qué.
 */
export const CONFIRM_Z_INDEX = 2400;

/** Variantes: danger (eliminar) | warning | info */
export const CONFIRM_VARIANTS = {
  danger: {
    accent: '#FF453A',
    iconBg: '#CE0000',
    iconColor: '#FFFFFF',
    confirmBg: '#CE0000',
    confirmBgHover: '#B00000',
    Icon: CloseIcon,
  },
  warning: {
    accent: '#FBBF24',
    iconBg: '#FBBF24',
    iconColor: '#1C1C1C',
    confirmBg: '#489291',
    confirmBgHover: '#3A7A79',
    Icon: WarningAmberIcon,
  },
  info: {
    accent: '#489291',
    iconBg: '#489291',
    iconColor: '#FFFFFF',
    confirmBg: '#489291',
    confirmBgHover: '#3A7A79',
    Icon: InfoOutlinedIcon,
  },
};
